export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white">
      
      <img
        src="/assets/logo/surbanco-logo.png"
        alt="SURBANCO"
        className="h-24 w-24 animate-pulse"
      />

      <h1 className="mt-6 text-3xl font-bold text-[#7A1F1F]">
        SURBANCO
      </h1>

      <p className="mt-2 text-gray-500">
        Sitaburdi Urban Credit Cooperative Society
      </p>

      <div className="mt-6 h-2 w-64 overflow-hidden rounded-full bg-gray-200">
        <div className="h-full animate-[loading_2s_linear_infinite] bg-[#D4AF37]"></div>
      </div>

    </div>
  );
}